// The public page resolves each document ID to its current Firebase file URL.
const doc = (documentId) => ({ documentId });
export const pageLinks = {
  Home: "https://risingstarspublicschool.com/",
  Facilities: "https://risingstarspublicschool.com/facilities/",
  "Class Rooms": "https://risingstarspublicschool.com/class-rooms",
  Playground: "https://risingstarspublicschool.com/playground",
  Transport: "https://risingstarspublicschool.com/transport",
  Security: "https://risingstarspublicschool.com/security",
  Library: "https://risingstarspublicschool.com/library",
  "Computer Room": "https://risingstarspublicschool.com/computer-room",
  Lab: "https://risingstarspublicschool.com/lab",
  Events: "https://risingstarspublicschool.com/events/",
  "News & Media": "https://risingstarspublicschool.com/news-and-media/",
  Blogs: "https://risingstarspublicschool.com/blogs/",
  "Photo Gallery": "https://risingstarspublicschool.com/photos/",
  "Video Gallery": "https://risingstarspublicschool.com/videos/",
  "Required Documents":
    "https://risingstarspublicschool.com/required-documents",
  "Prescribed Books": "https://risingstarspublicschool.com/prescribed-books",
  Documents: "https://risingstarspublicschool.com/documents",
  Circulars: "https://risingstarspublicschool.com/circulars",
  Curriculum: "https://risingstarspublicschool.com/curriculum",
  "Fee Structure": "https://risingstarspublicschool.com/fee-structure",
  "About Us": "https://risingstarspublicschool.com/about/",
  "Our Mission": "https://risingstarspublicschool.com/our-mission/",
  "Our Vision": "https://risingstarspublicschool.com/our-vision/",
  Achievers: "https://risingstarspublicschool.com/achievers/",
  "Aim & Objectives": "https://risingstarspublicschool.com/aims-and-objective/",
  "Principal's Message":
    "https://risingstarspublicschool.com/principal-message/",
  "Management Committee":
    "https://risingstarspublicschool.com/management-committee/",
  "Mandatory Public Disclosure":
    "https://risingstarspublicschool.com/mandatory-public-disclosure/",
  Prospectus: "https://risingstarspublicschool.com/prospectus/",
  "Annual Report": "https://risingstarspublicschool.com/annual-reports/",
  "Annual Reports": "https://risingstarspublicschool.com/annual-reports/",
  Reviews: "https://risingstarspublicschool.com/reviews/",
  Contact: "https://risingstarspublicschool.com/contact/",
  "Inquire Now": "https://risingstarspublicschool.com/contact/",
  "Campus Safety": "https://risingstarspublicschool.com/facilities/",
  "Student Activities": "https://risingstarspublicschool.com/events/",
  "Academic Department": "https://risingstarspublicschool.com/curriculum",
  "Planning & Administration": "https://risingstarspublicschool.com/about/",
  "Office Of The Chancellor":
    "https://risingstarspublicschool.com/management-committee/",
  "Facility Services": "https://risingstarspublicschool.com/facilities/",
};
export const nav = [
  {
    label: "Facilities",
    items: [
      "Class Rooms",
      "Playground",
      "Transport",
      "Security",
      "Library",
      "Computer Room",
      "Lab",
    ],
  },
  {
    label: "Admissions",
    items: [
      "Required Documents",
      "Prescribed Books",
      "Documents",
      "Circulars",
      "Curriculum",
      "Fee Structure",
    ],
  },
  {
    label: "Pages",
    items: [
      "About Us",
      "Our Mission",
      "Our Vision",
      "Achievers",
      "Aim & Objectives",
      "Principal's Message",
      "Management Committee",
      "Mandatory Public Disclosure",
      "Prospectus",
      "Annual Report",
      "Reviews",
      "Contact",
    ],
  },
];
export const general = [
  ["1", "NAME OF SCHOOL", "Rising Stars Public School"],
  ["2", "AFFILIATION NO (IF APPLICABLE)", "2133714"],
  ["3", "SCHOOL CODE (IF APPLICABLE)", "80048"],
  [
    "4",
    "COMPLETE ADDRESS PIN CODE",
    "6Km Stone From Kemri Tiraha Bilaspur, Rampur UP-244921",
  ],
  ["5", "PRINCIPAL NAME & QUALIFICATION", "Mrs. Pushpa Bisht"],
  ["6", "SCHOOL EMAIL ID", { mail: "contact@risingstarspublicschool.com" }],
  ["7", "CONTACT DETAILS (MOBILE)", "8920044149"],
];
export const documents = [
  [
    "1",
    "COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY",
    doc("affiliation-upgradation-letter"),
  ],
  [
    "2",
    "COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE",
    doc("society-trust-registration"),
  ],
  [
    "3",
    "COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED,IF APPLICABLE.BY THE STATE GOVT./UT",
    doc("state-noc"),
  ],
  [
    "4",
    "COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE",
    doc("building-safety-certificate"),
  ],
  [
    "5",
    "COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY",
    doc("fire-safety-certificate"),
  ],
  [
    "6",
    "COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION EXTENSION OF AFFILIATIONOR SELF CERTIFICATION BY SCHOOL",
    doc("deo-certificate"),
  ],
  [
    "7",
    "COPIES OF VALID WATER HEALTH AND SANITATION CERTIFICATES",
    doc("water-health-sanitation-certificate"),
  ],
  ["8", "MANDATORY PUBLIC DISCLOSURE", doc("mandatory-public-disclosure")],
  [
    "9",
    "COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT’S RENEWAL",
    doc("rte-recognition-certificate"),
  ],
];
export const academics = [
  ["1", "FEE STRUCTURE OF THE SCHOOL", doc("fee-structure")],
  ["2", "ANNUAL ACADEMIC CALENDAR", doc("annual-academic-calendar")],
  [
    "3",
    "LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)",
    doc("school-management-committee"),
  ],
  [
    "4",
    "LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS",
    doc("parents-teachers-association"),
  ],
  [
    "5",
    "LATEST THREE YEAR RESULT OF BOARD EXAMINATION AS PER APPLICABILITY",
    doc("three-year-board-results"),
  ],
];
export const staff = [
  ["1", "PRINCIPAL", "01"],
  ["2", "TOTAL NO. OF TEACHER", "31"],
  ["A", "PGT", "6"],
  ["B", "TGT", "10"],
  ["C", "PRT", "12"],
  ["3", "TEACHERS SECTION RATIO", "1:1.5"],
  ["4", "DETAILS OF SPECIAL EDUCATOR", "01"],
  ["5", "DETAILS OF COUNSELLOR AND WELLNESS TEACHER", "01"],
  ["6", "Classes", "29"],
];
export const infra = [
  ["1", "TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)", "8093.64 sq mtr"],
  [
    "2",
    "NO. AND SIZE OF THE CLASSROOMS (IN SQ MTR)",
    "20(7.6×6.2) 47.12 sq mtr",
  ],
  [
    "3",
    "NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)",
    "(71.5×6) 69 sq mtr (11.5×6) 47.12 sq mtr",
  ],
  ["4", "INTERNET FACILITY", "Yes"],
  ["5", "NO. OF GIRLS TOILET", "19"],
  ["6", "NO. OF BOYS TOILET", "5"],
  [
    "7",
    "LINK OF THE YOUTUBE VIDEO OF THE INSPECTION OF THE SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL",
    {
      video: "",
    },
  ],
];
export const quickLinks = [
  "About Us",
  "Our Mission",
  "Our Vision",
  "Achievers",
  "Aim & Objectives",
  "Principal's Message",
  "Management Committee",
  "Prospectus",
  "Annual Reports",
  "Reviews",
  "Contact",
];
export const footerCols = {
  Facilities: [
    "Campus Safety",
    "Student Activities",
    "Academic Department",
    "Planning & Administration",
    "Office Of The Chancellor",
    "Facility Services",
  ],
  Gallery: ["Photo Gallery", "Video Gallery"],
  Admission: [
    "Required Documents",
    "Prescribed Books",
    "Documents",
    "Circulars",
    "Curriculum",
    "Fee Structure",
  ],
};
